<main>
  <section
    style="
      background-image: url('assets/images/about-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light py-5"></div>
      </div>
    </div>
  </section>

  <div class="container">
    <div class="d-md-flex flex-md-equal w-100 pt-5 my-md-5">
      <div class="overflow-hidden">
        <img
          src="assets/images/about-story.jpg"
          alt="Field of healthy soybeans bordered by a growing corn field and a harvested wheat field."
        />
      </div>
      <div class="px-3 px-md-5 overflow-hidden">
        <div class="mb-3 p-3">
          <p class="display-6 text-primary mb-4">Our Story</p>
          <p>
            DFS is America's largest family-owned ag lender and a proud
            subsidiary of First National of Nebraska. Like DFS, First National
            of Nebraska has deep heartland roots and a long history of serving
            the agriculture community. For over 50 years, DFS has been a
            respected leader in equipment finance, forging long-term
            partnerships with equipment dealers, dealer associations,
            manufacturers, and customers.
          </p>
          <p>
            We look at the American agriculture story with fondness and respect.
            And it's a story we're proud to play an important part in. New
            challenges present themselves every year that force the ag industry
            to innovate. We do the same, always looking for ways to provide
            better flexibility and solutions that keep growers growing, on the
            cutting-edge, and protected from loss.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-fluid bg-primary px-5 mb-5"
    style="margin-top: 175px; padding-bottom: 100px"
  >
    <div class="row justify-content-center">
      <div
        class="d-md-flex flex-md-equal w-100 ps-md-3"
        style="margin-top: -100px; max-width: 1400px"
      >
        <div class="bg-secondary pt-3 pb-4 px-3 px-md-5 overflow-hidden">
          <div class="my-3 p-3">
            <h2 class="fs-4 mb-4">Careers at DFS</h2>
            <p class="mb-4">
              We're always looking for exceptional people who care about people
              and their work.
            </p>
            <a
              class="btn btn-primary"
              href="https://www.fnbo.com/careers"
              target="_blank"
              >See Job Openings</a
            >
          </div>
        </div>
        <div class="bg-success pt-3 pb-4 px-3 px-md-5 overflow-hidden">
          <div class="my-3 py-3">
            <h2 class="fs-4 mb-4">Already have an account?</h2>
            <p class="mb-4">
              Login to manage claims, or access your agency information through
              our company website.
            </p>
            <a class="btn btn-primary" routerLink="/login">Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
